import { render, staticRenderFns } from "./ToastAlertas.vue?vue&type=template&id=66490065"
import script from "./ToastAlertas.vue?vue&type=script&lang=js"
export * from "./ToastAlertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports